import { style } from "@vanilla-extract/css";
import { primitiveTokens } from "../theme/ThemeTokens.css";

export const metricTileValue = style({
  margin: `0 0 ${primitiveTokens.sizing["2x"]}`,
  fontSize: primitiveTokens.type.xxl,
  fontWeight: 700
});

export const metricTileNote = style({
  margin: "0",
  fontSize: primitiveTokens.type.xs,
  opacity: 0.6,
  overflow: "hidden",
  whiteSpace: "nowrap",
  textOverflow: "ellipsis"
});
